export default __webpack_public_path__ + "static/media/01.1b6efec7.png";